import fancyBox from './fancybox';

const $insightsDetail = $('.insights-detail');

const self = {};

self.loadVideos = function loadVideos() {
  const $videos = $('.videos', $insightsDetail);

  const $thumbCarousel = $('.vidThumbSlider', $videos);

  $thumbCarousel.slick({
    arrows: true,
    centerMode: true,
    centerPadding: 0,
    dots: false,
    draggable: false,
    infinite: true,
    /* eslint-disable max-len */
    nextArrow: '<button class="slick-next" type="button"><span class="sr-only">Previous</span></i></button>',
    prevArrow: '<button class="slick-prev" type="button"><span class="sr-only">Next</span></button>',
    /* eslint-enable max-len */
    slidesToShow: 2,
    slidesToScroll: 1,
    swipe: false,

    responsive: [{
      breakpoint: 1600,
      settings: {
        slidesToShow: 1,
      },
    }, {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
      },
    }, {
      breakpoint: 980,
      settings: {
        slidesToShow: 1,
      },
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    }],
  });

  const $videoLinks = $videos.find('.video a');
  fancyBox.applyFancyBoxVideo($videoLinks);
};

self.loadPromos = function loadPromos() {
  const $insightsCarousel = $('.promosSlider', $insightsDetail);

  $insightsCarousel.slick({
    arrows: true,
    centerMode: true,
    centerPadding: 0,
    dots: false,
    draggable: false,
    infinite: true,
    /* eslint-disable max-len */
    nextArrow: '<button class="slick-next" type="button"><span class="sr-only">Previous</span></i></button>',
    prevArrow: '<button class="slick-prev" type="button"><span class="sr-only">Next</span></button>',
    /* eslint-enable max-len */
    slidesToShow: 2,
    slidesToScroll: 1,
    swipe: false,

    responsive: [{
      breakpoint: 1600,
      settings: {
        slidesToShow: 1,
      },
    }, {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
      },
    }, {
      breakpoint: 980,
      settings: {
        slidesToShow: 1,
      },
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    }],
  });
};

self.loadSpecifications = function loadSpecifications() {
  const $specificationsCarousel = $('.specifications-slider', $insightsDetail);

  // if ($specificationsCarousel.children().length <= 1) {
  //   return;
  // }

  $specificationsCarousel.slick({
    arrows: true,
    centerMode: true,
    centerPadding: 0,
    dots: false,
    draggable: false,
    infinite: true,
    /* eslint-disable max-len */
    nextArrow: '<button class="slick-next" type="button"><span class="sr-only">Previous</span></i></button>',
    prevArrow: '<button class="slick-prev" type="button"><span class="sr-only">Next</span></button>',
    /* eslint-enable max-len */
    slidesToShow: 2,
    slidesToScroll: 1,
    swipe: false,

    responsive: [{
      breakpoint: 1600,
      settings: {
        slidesToShow: 2,
      },
    }, {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    }, {
      breakpoint: 980,
      settings: {
        slidesToShow: 2,
      },
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      },
    }],
  });
};

self.loadNavigation = function loadNavigation() {
  const $navigationItems = $insightsDetail.find('[data-nav-title]');

  if ($navigationItems.length > 0) {
    const $nav = $('<div/>', { class: 'side-nav fixed-right legacy' }).append($('<ul/>'));
    const topOffset = $('header').height();

    const setCurrentlyActive = function setCurrentlyActive() {
      let defaultSelected = false;

      $.each($navigationItems, function each(index) {
        const $this = $(this);
        const sectionpos = $this.offset();
        const sectionY = sectionpos.top - topOffset;
        const yScrollPosition = window.pageYOffset;

        if (yScrollPosition > sectionY) {
          $(`.side-nav ul li:eq(${index})`).addClass('active');
          $(`.side-nav ul li:gt(${index})`).removeClass('active');
          $(`.side-nav ul li:lt(${index})`).removeClass('active');

          defaultSelected = true;
        }
      });

      if (!defaultSelected) {
        $nav.find('li').first().addClass('active');
      }
    };

    $.each($navigationItems, function each() {
      const $this = $(this);
      const title = $this.data('nav-title');

      const $listItem = $('<li/>')
        .append($('<span/>', { class: 'popout', text: title }))
        .append($('<span/>', { class: 'circle' }));

      $listItem.click(function click() {
        /* eslint-disable no-shadow */
        const $this = $(this);
        const title = $this.find('.popout').text();
        /* eslint-enable no-shadow */

        // It's assumed they're going to have each nav item with a
        // unique title as it'll choose the first to scroll to
        const $section = $insightsDetail.find(`[data-nav-title="${title}"]`);

        $('html, body').animate({
          scrollTop: ($section.offset().top) - (topOffset + 1),
        }, 1300);

        $nav.find('li').removeClass('active');
        $this.addClass('active');
      });

      $nav.find('ul').append($listItem);
    });

    $nav.prependTo($insightsDetail);

    setCurrentlyActive();

    $(window).on('scroll', () => {
      setCurrentlyActive();
    });
  }
};

self.loadVideos();
self.loadPromos();
self.loadSpecifications();
self.loadNavigation();
